/*
 *
 *   reducer
 *
 */
import produce from "immer"
import key from "./key"

import {
  LOAD_RECORD,
  LOAD_RECORD_SUCCESS,
  LOAD_RECORD_ERROR,
  LOAD_RECORDS,
  LOAD_CLIENT_RECORD,
  LOAD_RECORDS_SUCCESS,
  LOAD_RECORDS_ERROR,
  LOAD_RECORD_CLIENT_DETAILS,
  LOAD_RECORD_CLIENT_DETAILS_SUCCESS,
  LOAD_RECORD_CLIENT_DETAILS_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA_SUCCESS,
  CREATE_RECORD_SUCCESS,
  CREATE_RECORD_ERROR,
  UPDATE_RECORD_SUCCESS,
  UPDATE_RECORD_ERROR,
  DELETE_RECORD_SUCCESS,
  DELETE_RECORD_ERROR,
  UPDATE_CLIENT_RECORD_SUCCESS,
  UPDATE_CLIENT_RECORD_ERROR,
  DELETE_CLIENT_RECORD_SUCCESS,
  DELETE_CLIENT_RECORD_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS_ERROR,
  UPDATE_CLIENT_STATUS_SUCCESS,
  UPDATE_CLIENT_STATUS_ERROR,
  LEAD_STATUS_SUCCESS,
  LEAD_STATUS_ERROR,
  UPDATE_CLIENT_PROFILE_RECORD_SUCCESS,
  UPDATE_CLIENT_PROFILE_RECORD_ERROR,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID_SUCCESS,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID_ERROR,
  LOAD_CLIENT_QUESTIONS_LIST_SUCCESS,
  ADD_CLIENT_QUESTIONS_LIST_SUCCESS,
  ADD_CLIENT_QUESTIONS_LIST_ERROR,
  LOAD_CLIENT_QUESTIONS_LIST_ERROR,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST_SUCCESS,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST_ERROR,
  NEW_LEAD_CREATION_SUCCESS,
  NEW_LEAD_CREATION_ERROR,
  
} from "./constants"

const initialState = {
  records: [],
  record: {},
  record_client_details: [],
  questions_list: [],
  client_questions_list: [],
  record_profile: [],
  record_client_profile: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
}

export default function Reducer(
  state = initialState,
  {
    type,
    id,
    record,
    records,
    record_profile,
    record_client_profile,
    questions_list,
    client_questions_list,
    recordsMetaData = {},
    error,
    success,
    record_client_details,
   
  }
) {
  return produce(state, (draft) => {

    // console.log("Switch type -->", type)
    // console.log("Switch type record_client_profile -->", record_client_profile)

    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORDS:
      case LOAD_RECORD:
      case LOAD_CLIENT_RECORD:
        draft.record_profile = record_profile
        draft.loading = true
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_CLIENT_DETAILS:
        draft.loading = true
        draft.error = false
        draft.success = false
        break
       
      case LOAD_RECORDS_SUCCESS:
        draft.records = records
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_SUCCESS:
        draft.record = record
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_CLIENT_PROFILE_BY_ID_SUCCESS:
        draft.record_client_profile = record_client_profile
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_CLIENT_DETAILS_SUCCESS:
        draft.record_client_details = record_client_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_CLIENT_QUESTIONS_LIST_SUCCESS:
        draft.questions_list = questions_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_CLIENT_DETAILS_QUESTIONS_LIST_SUCCESS:
        draft.client_questions_list = client_questions_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = Object.assign(
          {},
          state.recordsMetaData,
          recordsMetaData
        )
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_CLIENT_DETAILS_META_DATA_SUCCESS:
        draft.recordsMetaData = Object.assign(
          {},
          state.recordsMetaData,
          recordsMetaData
        )
        draft.error = false
        draft.success = false
        break

      case LOAD_RECORD_CLIENT_DETAILS_META_DATA:
        draft.recordsMetaData = Object.assign(
          {},
          state.recordsMetaData,
          recordsMetaData
        )
        draft.error = false
        draft.success = false
        break
      case CREATE_RECORD_SUCCESS:
        draft.records = [record].concat(state.records)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case ADD_CLIENT_QUESTIONS_LIST_SUCCESS:
        draft.records = [record].concat(state.records)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case NEW_LEAD_CREATION_SUCCESS:
        draft.records = [record].concat(state.records)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_RECORD_SUCCESS:
      case UPDATE_CLIENT_RECORD_SUCCESS:
      case UPDATE_CLIENT_PROFILE_RECORD_SUCCESS:
        draft.records = state.records.find((r) => record._id === r._id)
          ? state.records.map((r) =>
              record._id === r._id ? Object.assign({}, r, record) : r
            )
          : state.records.concat([{ ...record }])
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case DELETE_CLIENT_RECORD_SUCCESS:
      case DELETE_RECORD_SUCCESS:
        draft.records = state.records.filter(
          (r) => r._id.toString() !== id.toString()
        )
        draft.loading = false
        draft.error = false
        draft.success = success
        break

      case UPDATE_CLIENT_STATUS_SUCCESS:
      case UPDATE_STATUS_SUCCESS:
        draft.records =
          record.status === 3 && record[`${atob(key)}Id`]
            ? draft.records.filter(
                (r) => !record[`${atob(key)}Id`].includes(r._id)
              )
            : record.status === 2 && record[`${atob(key)}Id`]
            ? draft.records.map((r) =>
                record[`${atob(key)}Id`].includes(r._id)
                  ? Object.assign({}, r, { status: false })
                  : r
              )
            : record.status === 1 && record[`${atob(key)}Id`]
            ? draft.records.map((r) => Object.assign({}, r, { status: 1 }))
            : draft.records || []
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LEAD_STATUS_SUCCESS:
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LOAD_RECORDS_ERROR:
      case NEW_LEAD_CREATION_ERROR:
      case LOAD_CLIENT_QUESTIONS_LIST_ERROR:
      case LOAD_CLIENT_DETAILS_QUESTIONS_LIST_ERROR:
      case LOAD_RECORD_ERROR:
      case LOAD_RECORD_CLIENT_PROFILE_BY_ID_ERROR:
      case LOAD_RECORD_CLIENT_DETAILS_ERROR:
      case CREATE_RECORD_ERROR:
      case ADD_CLIENT_QUESTIONS_LIST_ERROR:
      case UPDATE_RECORD_ERROR:
      case DELETE_RECORD_ERROR:
      case UPDATE_STATUS_ERROR:
      case UPDATE_CLIENT_RECORD_ERROR:
      case UPDATE_CLIENT_PROFILE_RECORD_ERROR:
      case DELETE_CLIENT_RECORD_ERROR:
      case UPDATE_CLIENT_STATUS_ERROR:
      case LEAD_STATUS_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
      case LOAD_RECORDS_META_DATA_ERROR:
        draft.error = error
        draft.success = false
        break
      case LOAD_RECORD_CLIENT_DETAILS_META_DATA_ERROR:
        draft.error = error
        draft.success = false
        break
    }
  })
}
